import { createSlice } from "@reduxjs/toolkit";
import { SELECTED_STORE } from "lib/Constants";
import { getLocalStorageData } from "lib/utils";

interface InitialStateInterface{
    listLoading:boolean;
    customerList:Record<string, string>[];
    customerSearchList:Record<string, string>[];
    selectedStore:Record<string,any>
}
const InitialState:InitialStateInterface={
    listLoading:true,
    customerList:[],
    customerSearchList:[],
    selectedStore:getLocalStorageData(SELECTED_STORE) || {}
}

const customerSlice= createSlice({
    name:"customer",
    initialState:InitialState,
    reducers:{
        setCustomerList:(state,{payload})=>{
         state.customerList= payload
        },
        setListLoading:(state,{payload})=>{
            state.listLoading= payload
        },
        setCustomerSearchList:(state,{payload})=>{
            state.customerSearchList= payload
           },
        setSelectedStore:(state,{payload})=>{
            state.selectedStore= payload
           }
    }
})

export const {setCustomerList,setListLoading,setCustomerSearchList,setSelectedStore} = customerSlice.actions;
export default customerSlice.reducer